// import React from 'react';
// import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

// const ContactSection = () => {
//   return (
//     <main className="container">
//       <div className="card mb-3 w-100">
//         <h4 className="text-center mb-4 montserrat-heading">We're here to help you.</h4> {/* Montserrat applied */}
//         <div className="row justify-content-between align-items-center">
//           {/* Contact Information Section with Icons */}
//           {/* <div className="col-md-4 poppins-text text-start d-flex align-items-center mb-3 mb-sm-4">
//             <FaPhoneAlt className="me-2" /> 
//             <p className="mb-0"><strong>Phone:</strong> 080-71189555</p>
//           </div> */}

//           <div className="col-md-4 poppins-text text-start d-flex align-items-center mb-3 mb-sm-4">
//             <FaEnvelope className="me-2" /> {/* Email icon */}
//             <p className="mb-0"><strong>Email:</strong> connect@midcbreastinfraredtech.com</p>
//           </div>

//           {/* <div className="col-md-4 poppins-text text-start d-flex align-items-center mb-3 mb-sm-4">
//             <FaMapMarkerAlt className="me-2" /> 
//             <p className="mb-0"><strong>Location:</strong> Bangalore, India</p>
//           </div> */}
//         </div>

//         {/* Google Map Section 
//         <div className="row">
//           <div className="col-md-12">
//             <iframe
//               src="https://www.google.com/maps/embed?pb=..."
//               width="100%"
//               height="300"
//               style={{ border: '0' }}
//               allowFullScreen=""
//               loading="lazy"
//             ></iframe>
//           </div>
//         </div> */}
//       </div>
//     </main>
//   );
// };

// export default ContactSection;

import React from 'react';
import { FaEnvelope } from 'react-icons/fa';

const ContactSection = () => {
  return (
    <main className="container my-5">
      <div className="card w-100 p-4 shadow-sm">
        <h4 className="text-center mb-4 montserrat-heading">We're here to help you.</h4>

        <div className="row justify-content-center">
          <div className="col-md-6 d-flex justify-content-center align-items-center poppins-text">
            <FaEnvelope
              className="me-2"
              style={{
                background: 'linear-gradient(90deg, #D145EB, #F676DE)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            />
            <a
              href="mailto:connect@midcbreastinfraredtech.com"
              className="text-dark text-decoration-none"
            >
              <strong>Email:</strong> connect@midcbreastinfraredtech.com
            </a>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ContactSection;
